import { Box, Divider, Grid, Tab } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { StyledTabs } from '../../common/StyledComponents';
import { scrollableY } from '../../common/theme/scrollbar';
import { RootState } from '../../store';
import ManageGroupGeneral from './ManageGroupGeneral';
import ManageGroupMembers from './ManageGroupMembers';
import { ManageGroupPermissions } from './ManageGroupPermissions';
import { getSelectedUserGroup } from './redux/userGroupSelectors';
import { UserGroup, userGroupSelected } from './redux/userGroupSlices';
import UserGroupList from './UserGroupList';
const mapStateToProps = (state: RootState) => ({
    selectedUserGroup: getSelectedUserGroup(state)
});

type Props = ReturnType<typeof mapStateToProps>;

const UserGroupComponent = ({ selectedUserGroup }: Props) => {
    const [tabIndex, setTabIndex] = useState(0);

    const dispatch = useDispatch();

    const handleTabChange = (event: SyntheticEvent<Element, Event>, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    const handleSetSelectedUserGroup = (ug: UserGroup) => {
        dispatch(userGroupSelected(ug.userGroupId));
    };

    return (
        <Grid sx={{ flexFlow: 'row' }} container>
            <Grid item xs={2} sx={theme => ({ ...scrollableY(theme) })}>
                <UserGroupList
                    selectedUserGroup={selectedUserGroup}
                    setSelectedUserGroup={handleSetSelectedUserGroup}
                />
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs={10} sx={{ paddingLeft: '10px' }}>
                <StyledTabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="General" />
                    <Tab label="Users" />
                    <Tab label="Permissions" />
                </StyledTabs>

                {selectedUserGroup != null ? (
                    <Box p={2}>
                        {tabIndex === 0 && <ManageGroupGeneral />}
                        {tabIndex === 1 && <ManageGroupMembers />}
                        {tabIndex === 2 && <ManageGroupPermissions />}
                    </Box>
                ) : (
                    <p>Choose a user group to see more details about it</p>
                )}
            </Grid>
        </Grid>
    );
};

export default connect(mapStateToProps)(UserGroupComponent);
